import { inject } from '@angular/core';
import { AccessService } from 'app/core/access/access.service';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { MessagesService } from 'app/layout/common/messages/messages.service';
import { NotificationsService } from 'app/layout/common/notifications/notifications.service';
import { QuickChatService } from 'app/layout/common/quick-chat/quick-chat.service';
import { ShortcutsService } from 'app/layout/common/shortcuts/shortcuts.service';
import { forkJoin, switchMap, tap } from 'rxjs';
import { UserService } from './core/user/user.service';
import { OrganizationService } from './core/organization/organization.service';

export const initialDataResolver = () => {
    const messagesService = inject(MessagesService);
    const navigationService = inject(NavigationService);
    const notificationsService = inject(NotificationsService);
    const quickChatService = inject(QuickChatService);
    const shortcutsService = inject(ShortcutsService);
    const usersService = inject(UserService);
    const branchesService = inject(OrganizationService);
    const suppliersService = inject(OrganizationService);
    const accessService = inject(AccessService);

    // First getMenuByUser, load access map, then the rest
    return usersService.getMenuByUser().pipe(
        tap((menuItems) => accessService.load(menuItems)),
        switchMap(() => 
            forkJoin([
                navigationService.get(),
                messagesService.getAll(),
                notificationsService.getAll(),
                quickChatService.getChats(),
                shortcutsService.getAll(),
                usersService.get(),
                usersService.getCurrentSystemUser(),
                branchesService.getBranches(),
                suppliersService.getSuppliers(),
                branchesService.getAllCorporateNames()
            ])
        )
    );
};
